import { render, staticRenderFns } from "./LecturesGrid.vue?vue&type=template&id=cae2b306"
import script from "./LecturesGrid.vue?vue&type=script&lang=js"
export * from "./LecturesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports